import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const beforeItems = ['Cada toma empieza con dolor, tensión o miedo a que algo salga mal.', 'No sabés si el bebé toma suficiente ni cómo interpretar las señales.', 'Los brotes, grietas o el pecho blando te dejan sin respuestas claras.', 'Los consejos del entorno se contradicen y terminás más confundida.', 'La lactancia se vuelve agotadora cuando debería ser un momento de conexión.'];
const afterItems = ['Entendés qué mirar para construir un agarre más cómodo y efectivo.', 'Sabés reconocer señales de alimentación, pañales y producción.', 'Tenés un protocolo concreto para los momentos difíciles y los brotes.', 'Podés tomar decisiones con información y sin caer en mitos.', 'Vivís cada toma con más calma, presencia y confianza.'];
export function BeforeAfter() {
  return <section className="bg-brand-cream px-4 py-16 md:py-20" data-id="element-33" data-mp="30qgj7b0irgm4">
      <div className="mx-auto max-w-6xl" data-id="element-34" data-mp="30s02zbldw9sn">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mx-auto mb-10 max-w-3xl text-center" data-id="element-35" data-mp="x3irisj8h5ni">
          <p className="text-sm font-bold tracking-[0.14em] text-brand-accent uppercase" data-id="element-36" data-mp="171f2nkc680lm">Un cambio posible</p>
          <h2 className="mt-3 font-serif text-4xl text-brand-darker md:text-5xl" data-id="element-37" data-mp="1246ft6g2v8e1">
            De sobrevivir cada toma a saber qué hacer.
          </h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-38" data-mp="9g0v2jp0xje7">
          <motion.article initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-3xl border border-brand-accent/35 bg-[#fdf0ec] p-7 md:p-8" data-id="element-39" data-mp="9d4xiwh38wqa">
            <h3 className="font-serif text-3xl text-brand-darker" data-id="element-40" data-mp="3rrnvx43bfsnl">Sin un mapa claro</h3>
            <ul className="mt-6 space-y-4" data-id="element-41" data-mp="3msujlezrm7p0">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-brand-darker/75" data-id="element-42" data-mp="1qriyfdjcw9mg">
                  <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-accent" aria-hidden="true" data-id="element-43" data-mp="1vpkia0olwcyz" />
                  <span data-id="element-44" data-mp="20g0vpksffylc">{item}</span>
                </li>)}
            </ul>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-3xl border border-brand-primary/40 bg-[#edf2e8] p-7 md:p-8" data-id="element-45" data-mp="24ie1uab35yin">
            <h3 className="font-serif text-3xl text-brand-darker" data-id="element-46" data-mp="1cst1bxwje9y3">Con S.O.S. Lactancia</h3>
            <ul className="mt-6 space-y-4" data-id="element-47" data-mp="1guo0avqzwb8p">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-brand-darker/80" data-id="element-48" data-mp="1lsxw98kjnfvd">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-darker" aria-hidden="true" data-id="element-49" data-mp="2s6x9cnmba79o" />
                  <span data-id="element-50" data-mp="2x58lj502wtv2">{item}</span>
                </li>)}
            </ul>
          </motion.article>
        </div>
      </div>
    </section>;
}